import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { allStoreIds } from "../../constants/allStoreIds";

function ProductDetails({ productData, isLoading, id }) {
  const { t } = useTranslation();

  const [showDetails, setShowDetails] = useState(false);
  const productDetails = showDetails ? productData?.details : productData?.details?.substring(0, 250);

  function checkDetails() {
    if (productData?.details === "<p></p>") {
      return false;
    } else if (!productData?.details) {
      return false;
    } else {
      return true;
    }
  }

  function createImageTags(inputString) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    let htmlString = inputString.replace(urlRegex, (url) => {
      if (/\.(png|jpg|jpeg|gif|bmp)$/i.test(url)) {
        return `
        <div style="display: flex; justify-content: center; padding: 10px 10px 10px 10px;">
        <img src="${url}" alt="Image" style="width: 200px; object-fit: contain" />
        </div>
        `;
      } else {
        return url;
      }
    });
    return htmlString;
  }

  const productWordsCount = productData?.details?.trim() === "" ? 0 : productData?.details?.trim().split(/\s+/)?.length;

  const adRef = React.useRef(null);

  useEffect(() => {
    if (window.location.hostname === "en-dxb.thwifty.com") {
      if (window.adsbygoogle && adRef.current && !adRef.current.dataset.loaded) {
        try {
          window.adsbygoogle.push({});
          adRef.current.dataset.loaded = "true"; // mark as loaded
        } catch (e) {
          console.error("Adsense error", e);
        }
      }
    }
  }, [id]);

  return (
    <>
      {isLoading ? (
        <Skeleton variant="rect" height={"15px"} width={"50%"} />
      ) : (
        <>
          {checkDetails() && (
            <>
              {allStoreIds?.includes(Number(productData?.store_id)) ? (
                <>
                  <h5 className="cardTitle">{t("product_details")}</h5>
                  <div
                    style={{ color: "#38393a", fontSize: "13px", wordBreak: "auto-phrase" }}
                    dangerouslySetInnerHTML={{
                      __html: productDetails,
                    }}
                  ></div>
                  {productWordsCount > 200 && (
                    <div
                      onClick={() => setShowDetails(showDetails ? false : true)}
                      style={{ fontSize: "0.85rem", cursor: "pointer", color: "#4e93d9", fontWeight: 400 }}
                    >
                      {showDetails ? t("show_less") : t("show_more")}
                    </div>
                  )}
                </>
              ) : (
                <>
                  {Number(productData?.store_id) !== 9 && (
                    <>
                      <h5 className="cardTitle">{t("product_details")}</h5>
                      <div
                        style={{ color: "#38393a", fontSize: "13px", wordBreak: "auto-phrase" }}
                        dangerouslySetInnerHTML={{
                          __html: createImageTags(productDetails),
                        }}
                      ></div>
                      {productWordsCount > 200 && (
                        <div
                          onClick={() => setShowDetails(showDetails ? false : true)}
                          style={{ fontSize: "0.85rem", cursor: "pointer", color: "#4e93d9", fontWeight: 400 }}
                        >
                          {showDetails ? t("show_less") : t("show_more")}
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      {window.location.hostname === "en-dxb.thwifty.com" && (
        <>
          <ins
            className="adsbygoogle"
            style={{ display: "block", textAlign: "center" }}
            data-ad-layout="in-article"
            data-ad-format="fluid"
            data-ad-client="ca-pub-8319400367988841"
            data-ad-slot="7896718572"
            ref={adRef}
          />
        </>
      )}
    </>
  );
}

export default ProductDetails;
